import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Sidebar, Segment, Button, Menu, Icon, Label } from 'semantic-ui-react';
import { Link } from 'react-router-dom'
import moment from "moment";

import { createNewPlan, loadPlan, loadPlanFailure, getPlans, openPlanPage, getPlansFailure, getTree, uploadPlanToInterpreter } from '../../actions/plan'
import { createRisk, createRiskFailure, updateRisk, deleteRisk, updateRiskByLevel, deleteRiskByLevel, clearRisk, switchRisksVisibilityByLevel } from '../../actions/risk'
import { logOutToken } from '../../actions/app_token'
import { snackbarAddMessage } from '../../actions/snackbar';

import history from '../../history'
import * as paths from '../../constants'
import CollapsibleCard from '../../components/collapsible_card'
import TemplateUpdateModal from '../../components/template_update_alert'
import SystemHeader from '../../components/system_header'
import { getTranslations } from '../../actions/language'
import Feedback from '../../components/feedback'
import AppComponent from '../../components/app_component'
import CreatePlanModal from '../../components/create_plan_modal'
import NewEntryModal from '../../components/new_entry_modal'
import RiskCard from '../../components/risk_card'
import ControlsLink from '../../components/controls_link'
import UnwantedEventDescription from '../../components/controls_component/unwanted_event_description';

import { initNewWorkPhaseEntry, initNewActivityEntry, initNewHazardEntry, initNewUnwantedEventEntry, updateUnwantedEventColumns } from '../../helpers/risk_helpers';
import { textToHash, fetchPlanWithPendingReviews, formatPendingReviews, getText, hasIntersection } from '../../helpers';
import ObjectITButton from '../../components/developed_by_objectit';

import { toolTipManager } from '../../services/instanceService';
import ToolTip from '../../components/tool_tips/tool_tip';
import { PLAN_SCOPE_TIP_ID } from '../../constants';
import Api from '../../services/api';

import './index.css'

class PlanScope extends AppComponent {
  constructor(props){
    super(props)

    var state = {
      planId: this.props.match.params.plan_id,
      activeCards: [],
      riskCards: {},
      risks: [],
      sidebarShown: false,
      planName: "",
      loading: false,
      createModal: false,
      plansModal: false,
      plans: [],
      templates: [],
      templateOptions: [],
      updateLoading: false,
      toggledRisks: [],
      pendingReviews: [],
      pendingReviewsShown: true,
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
      languageName: this.props.language.name,
      createPlanModalShown: false,
      showNewEntryForm: false,
      projCtrlRgstrBtnShown: false
    }
    this.state = {...this.state, ...state }

    this.page = 1;
    this.allWorkPhases = []
    this.loadingMessage = this.props.language.translations.fetching_activities
    this.updateId = null
    this.updateType = null
    this.cancelActivityToggle = false
    this.URLSearchParams = this.getURLSearchParams();
  }

  componentWillMount = () => {
    this.setPermission()
    this.reloadLanguageTranslations()

    const { features } = this.props.instanceConfig
    const isAiChatbotEnabled = features && features.ai_chatbot

    if(isAiChatbotEnabled) {
      this.props.uploadPlanToInterpreter(this.props.match.params.plan_id)
    }

    fetchPlanWithPendingReviews(this.state.planId, (plan) => {
      this.setState({
        planName: plan.name,
        pendingReviews: formatPendingReviews(plan.pending_reviews)
      }, this.setExpandedCardsFromUrlSearchParams)
    })
  }

  componentDidUpdate = () => {
    this.scrollToWorkPhaseCardFromUrlSearchParams();
  }

  componentWillReceiveProps = (nextProps) => {
    var translations = nextProps.language.translations
    if (nextProps.language !== this.props.language){
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
      }, this.getRiskTree)
    }

    if (nextProps.loadSuccess) {
      this.setState({
        planName: nextProps.plan.name,
        pendingReviews: (this.page === 1) ? formatPendingReviews(nextProps.plan.pending_reviews) : this.state.pendingReviews,
      })
      this.props.resetLoad()
      this.getRiskTree()
    }
    else if (nextProps.updatePending){
      this.loadingMessage = translations.updating_risk + "..."
      this.setState({
        updateLoading: true,
      })
    }
    else if(nextProps.updateSuccess && (nextProps.updateSuccess !== this.props.updateSuccess)) {
      if (this.updateType) {
        this.getRiskTree()
      }
    }
    else if (nextProps.getPlansSuccess){
      if (nextProps.isTemplate){
        this.setState({
          templates: nextProps.plans,
          templateOptions: this.formatPlans(nextProps.plans),
          templatesModalShown: true
        })
      }
      else {
        this.setState({
          plans: this.formatPlans(nextProps.plans),
          plansModalShown: true
        })
      }
      this.props.resetGetPlans();
    }
    else if (nextProps.createPlanPending){
      this.loadingMessage = translations.create_a_plan
      this.setState({
        updateLoading: true,
        riskCards: {},
      })
    }
    else if(nextProps.updateByLevelPending && (nextProps.updateByLevelPending !== this.props.updateByLevelPending)) {
      this.loadingMessage = translations.updating_risk + "..."
      this.setState({
        updateLoading: true,
      })
    }
    else if(nextProps.updateByLevelSuccess && (nextProps.updateByLevelSuccess !== this.props.updateByLevelSuccess)) {
      this.getRiskTree()
    }
    else if(nextProps.deleteByLevelSuccess && (nextProps.deleteByLevelSuccess !== this.props.deleteByLevelSuccess)) {
      this.getRiskTree()
    }
    else if(nextProps.deleteByLevelPending) {
      this.loadingMessage = translations.deleting + "..."
      this.setState({
        updateLoading: true,
      })
    }
    else {
      this.setState({
        updateLoading: false,
      })
    }

    if (nextProps.tree !== this.props.tree){
      this.setState({
        riskTree: nextProps.tree,
        loading: false,
        updateLoading: false,
      }, this.toggleProjCtrlRgstrBtn)
      this.onRiskTreeLoaded(nextProps.tree)

      this.updateType = null
      this.updateId = null
      this.props.resetCreate()
      this.props.clearRisk()
    }
  }

  getRiskTree = () => {
    this.setState({
      loading: true,
    }, () => this.props.getTree(this.state.planId, "scope"))
  }

  onRiskTreeLoaded = (riskTree) => {
    for(var index in riskTree) {
      this.allWorkPhases = this.allWorkPhases.concat(riskTree[index].work_phase_or_ambient_exposure)
    }
  }

  formatPlans = (plans) => {
    var new_plans = []
    if (plans.length===0){
      return new_plans
    }

    for (var i in plans){
      var plan = {
        key: plans[i].id,
        value: plans[i].id,
        text: plans[i].name
      }
      new_plans = new_plans.concat(plan)
    }
    return new_plans
  }

  toggleActivity = (activity) => {
    let { activeCards=[] } = this.state;

    if(activeCards.filter(card => card === activity).length > 0) {
      activeCards = activeCards.filter(card => card !== activity)
    }
    else {
      activeCards = activeCards.concat(activity)
    }

    this.setState({ activeCards })
  }

  toggleActivities = (expand) => {
    var activeCards = []

    if(expand) {
      activeCards = this.allWorkPhases
    }

    this.setState({
      activeCards: activeCards,
    })
  }

  isActivityActive = (activity) => {
    var activeCards = this.state.activeCards

    if(activeCards === null) {
      return true
    }

    return (this.state.activeCards.filter(card => card.trim() === activity.trim()).length > 0)
  }

  onCreateRisk = (risk) => {
    this.updateType = "create"

    this.setState({ createModal: false })
    this.props.createRisk(this.state.planId, risk)
  }

  onUpdateUnwantedEvent = (value, risk) => {
    this.updateType = "update"
    this.updateId = risk.ids[0]

    let metadata = risk.metadata;
    metadata = updateUnwantedEventColumns(value, metadata);

    var updated_risk = {
      id: risk.ids[0],
      metadata: JSON.stringify(metadata)
    }

    this.props.updateRisk(this.state.planId, updated_risk)
  }

  onUpdateRisks = (value, search_term, column_name, risk) => {
    this.updateId = search_term
    this.props.updateRiskByLevel(this.state.planId, value, search_term, column_name, risk.work_phase_or_ambient_exposure, risk.activity)
  }

  onDeleteRisks = (search_term, column_name, risk) => {
    this.updateId = search_term
    this.props.deleteRiskByLevel(this.state.planId, search_term, column_name, risk.work_phase_or_ambient_exposure, risk.activity)
  }

  onDeleteUnwantedEvent = (risk) => {
    this.updateType = "delete"
    this.updateId = risk.ids[0]
    risk["id"] = risk.ids[0]
    this.props.deleteRisk(this.state.planId, risk)
  }

  onSubmitEntry = (risk) => {
    this.toggleNewEntryForm(false)
    this.onCreateRisk(risk)
  }

  toggleSideBar = () => {
    this.setState({ sidebarShown: true })
  }

  hideSideBar = () => {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  hideTemplatesModal = () => {
    this.setState({
      templatesModalShown: false
    })
  }

  hidePlansModal = () => {
    this.setState({
      plansModalShown: false
    })
  }

  switchRisksVisibility = (value, setSwitchVisibilityPending) => {
    const { planId } = this.state;

    const switchVisibilityParams = { ...value, plan_id: planId };

    setSwitchVisibilityPending(true);

    const api = new Api();
    return api.put("/__api/v1/risks/switch_visibility", switchVisibilityParams)
      .then(response => {
        if (response.status !== 200) return
        setSwitchVisibilityPending(false);
        this.switchRisksVisibilitySuccessCallback(switchVisibilityParams);
      })
      .catch(error => {
        console.error(error);
        setSwitchVisibilityPending(false);
        this.switchRisksVisibilityErrorCallback(switchVisibilityParams);
      });
  }

  switchRisksVisibilitySuccessCallback = (switchVisibilityParams) => {
    const { riskTree } = this.state;

    const newRiskTree = this.getUpdatedRiskTree(riskTree, switchVisibilityParams);

    this.setState({
      riskTree: newRiskTree,
    }, this.toggleProjCtrlRgstrBtn);
  }

  switchRisksVisibilityErrorCallback = (switchVisibilityParams) => {
    const { workPhase, activity, hazard, unwantedEvent, hidden } = switchVisibilityParams;

    const msgContent = (
      <Fragment>
        {
          hidden
          ?
          <div>{getText("The update did not happen because there was an error when marking risks as Out Of Scope.")} {getText("Below is the risk description.")}</div>
          :
          <div>{getText("The update did not happen because there was an error when marking risks as In Scope.")} {getText("Below is the risk description.")}</div>
        }
        <UnwantedEventDescription
          workPhase={workPhase}
          activity={activity}
          hazard={hazard}
          unwantedEvent={unwantedEvent}
        />
      </Fragment>
    )

    this.props.snackbarAddMessage({ header: getText("Error"), content: msgContent, type: "error", duration: 0 })
  }

  getUpdatedRiskTree = (nodes, params, depth = 0) => {
    const { risk_ids: riskIds, hidden } = params;
    const levels = ['activities', 'hazards', 'unwanted_events'];
    const currentKey = levels[depth];

    return nodes.map(node => {

      if (!hasIntersection(node.ids, riskIds)) return node;

      if (!currentKey) {
        return { ...node, hidden };
      }

      return {
        ...node,
        [currentKey]: this.getUpdatedRiskTree(node[currentKey], params, depth + 1)
      };
    });
  }

  renderWorkPhases = () => {
    var { riskTree, languageName, permission, translations } = this.state
    
    var cards = []
    const { unselected_activities, work_phase_or_ambient_exposure, new: new_label } = translations
 
    for(var index in riskTree) {
      var workPhase = riskTree[index]
      var cardId = workPhase.ids[0]
      var unselected_count = 0
      var in_scope_count = 0
      var out_scope_count = 0
      var total_activities = workPhase.activities.length

      for(var activityIndex in workPhase.activities) {
        var activity = workPhase.activities[activityIndex]
        var hidden = null
        let hazards_count = activity.hazards.length
        let hazards_in_scope_count = 0
        let hazards_out_of_scope_count = 0

        for(var hazardIndex in activity.hazards) {
          var hazard = activity.hazards[hazardIndex]
          let events_count = hazard.unwanted_events.length
          let events_in_scope_count = 0
          let events_out_of_scope_count = 0

          for(var eventIndex in hazard.unwanted_events) {
            var unwanted_event = hazard.unwanted_events[eventIndex]

            if(unwanted_event.hidden !== null) {
              if (hidden === null){
                hidden = unwanted_event.hidden
              }
              else {
                hidden = hidden || unwanted_event.hidden
              }

              if (unwanted_event.hidden) {
                events_out_of_scope_count++
              } else {
                events_in_scope_count++
              }
            }
          }

          if (events_in_scope_count === events_count) {
            hazards_in_scope_count++
          } else if (events_out_of_scope_count === events_count) {
            hazards_out_of_scope_count++
          }
        }

        if(hidden === null) {
          unselected_count++
        }
        else {
          if (hazards_in_scope_count === hazards_count) {
            in_scope_count++
          } else if (hazards_out_of_scope_count === hazards_count) {
            out_scope_count++
          }
        }

      }

      const riskDetails = {
        ...workPhase.metadata,
        id: cardId,
        is_custom: (workPhase.metadata.is_custom === "work_phase" ? workPhase.metadata.is_custom : "activity"),
        hidden: (in_scope_count === total_activities) ? true : ((out_scope_count === total_activities) ? false : null)
      };
      const newActivityRisk = initNewActivityEntry(riskDetails);

      var className = `cards-workphase-name ${languageName.toLowerCase()} work_phase`;
      if (unselected_count > 0) className = `${className} with-unselected`;

      const workPhaseText = (workPhase.translations[languageName] || '').trim();
      const workPhaseTextEnglish = (workPhase.translations["English"] || '').trim();
      const pendingReview = this.findPendingReview({ workPhaseText: workPhaseTextEnglish });
      const workPhaseId = textToHash(workPhaseTextEnglish);

      var headerContent = (
        <RiskCard
          className={ className }
          workPhase={workPhase}
          risk={newActivityRisk}
          onUpdatePending={ this.props.updateByLevelPending && (this.updateId === workPhaseTextEnglish) }
          onDeletePending={ this.props.deleteByLevelPending && (this.updateId === workPhaseTextEnglish) }
          onSaveClick={ this.onUpdateRisks }
          onDeleteClick={ this.onDeleteRisks }
          switchRisksVisibility={ this.switchRisksVisibility }
          languageName={languageName}
          translations={translations}
          permission={permission}
          unselectedCount={unselected_count}
          totalUnselectedCount={unselected_activities}
          selectLabel={translations.all_in_scope}
          unselectLabel={translations.all_out_of_scope}
          inScope={in_scope_count === total_activities}
          outOfScope={ out_scope_count === total_activities }
          pendingReview={pendingReview}
          cardType="Work Phase"
          riskIds={workPhase.ids}
        />
      )
      var content = this.renderActivities({ activities: workPhase.activities, workPhase })

      cards = cards.concat(
        <CollapsibleCard
          id={workPhaseId}
          expand={ this.isActivityActive(workPhaseTextEnglish) }
          onToggle={ (workPhase) => this.toggleActivity(workPhase) }
          key={ workPhaseTextEnglish }
          toggleKey={ workPhaseTextEnglish }
          headerLabel={ work_phase_or_ambient_exposure }
          headerText={ workPhaseText }
          headerContent={ headerContent }
          content={ content }
          className={ languageName.toLowerCase() + " work-phase" }
          newEntry={ {risk: newActivityRisk, name: this.state.translations.activity , callback: this.onSubmitEntry} }
          translations={ this.state.translations }
          columnName={(languageName === "English" ? "activity" : "activity_" + languageName.toLowerCase())}
          createPending={this.props.updatePending || this.state.loading}
          permission={permission}
        />
      )
    }

    if(!this.props.instanceConfig.enable_workphase_addition || riskTree.length===0 || !permission.can_update) return cards
  
    const newWorkPhaseRisk = initNewWorkPhaseEntry({ is_custom: "work_phase" });

    cards.push(
      <div className="collapsible new-entry-button-alignment" key='new_work_phase_card'>
        <div className="collapsible header" onClick={ () => this.toggleNewEntryForm(true) }>
          <div>
            <div className="collapsible-new-entry">
              <a className="collapsible-new-entry">
                <Icon name="plus"/>
                { new_label + " " + work_phase_or_ambient_exposure }
              </a>
            </div>
          </div>
          {
            this.state.showNewEntryForm &&
            <NewEntryModal
              headerText={ new_label + " " + work_phase_or_ambient_exposure }
              shown={ this.state.showNewEntryForm }
              risk={ newWorkPhaseRisk }
              onSubmit={this.onSubmitEntry}
              onClose={ () => this.toggleNewEntryForm(false) }
              translations={this.state.translations}
            />
          }
        </div>
      </div>
    )

    return cards
  }

  renderActivities = (kwargs) => {
    const { activities, workPhase } = kwargs;
    var { languageName, permission, translations } = this.state
    var cards = []

    for(var index in activities) {
      var activity = activities[index]
      var cardId = activity.ids[0]
      var hidden = null
      let hazards_count = activity.hazards.length;
      let hazards_in_scope_count = 0
      let hazards_out_of_scope_count = 0

      for(var hazardIndex in activity.hazards) {
        var hazard = activity.hazards[hazardIndex]

        let events_count = hazard.unwanted_events.length
        let events_in_scope_count = 0
        let events_out_of_scope_count = 0

        for(var eventIndex in hazard.unwanted_events) {
          var unwanted_event = hazard.unwanted_events[eventIndex]

          if (unwanted_event.hidden === null) {
            continue
          }

          if(unwanted_event.hidden !== null) {
            if (hidden === null){
              hidden = unwanted_event.hidden
            }
            else {
              hidden = hidden || unwanted_event.hidden
            }

            if (unwanted_event.hidden) {
              events_out_of_scope_count++
            } else {
              events_in_scope_count++
            }
          }
        }

        if (events_in_scope_count === events_count) {
          hazards_in_scope_count++
        } else if (events_out_of_scope_count === events_count) {
          hazards_out_of_scope_count++
        }

      }

      const riskDetails = {
        ...activity.metadata,
        id: cardId,
        is_custom: (['work_phase', 'activity'].includes(activity.is_custom) ? activity.is_custom : "hazard"),
        hidden: hidden
      };
      const newHazardRisk = initNewHazardEntry(riskDetails);

      const activityText = (activity.translations[languageName] || '').trim();
      const workPhaseTextEnglish = (workPhase.translations["English"] || '').trim();
      const activityTextEnglish = (activity.translations["English"] || '').trim();
      const pendingReview = this.findPendingReview({ workPhaseText: workPhaseTextEnglish, activityText: activityTextEnglish });

      var headerContent = (
        <RiskCard
          className={ `cards-workphase-name ${languageName.toLowerCase()} activity` }
          workPhase={workPhase}
          activity={activity}
          risk={newHazardRisk}
          onUpdatePending={ this.props.updateByLevelPending && (this.updateId === activityTextEnglish) }
          onDeletePending={ this.props.deleteByLevelPending && (this.updateId === activityTextEnglish) }
          onSaveClick={ this.onUpdateRisks }
          onDeleteClick={ this.onDeleteRisks }
          switchRisksVisibility={ this.switchRisksVisibility }
          languageName={languageName}
          translations={translations}
          permission={permission}
          selectLabel={translations.in_scope}
          unselectLabel={translations.out_of_scope}
          inScope={hazards_in_scope_count === hazards_count}
          outOfScope={hazards_out_of_scope_count === hazards_count}
          pendingReview={pendingReview}
          cardType="Activity"
          riskIds={activity.ids}
        />
      )
      var content = this.renderHazards({ hazards: activity.hazards, workPhase, activity })

      cards = cards.concat(
        <CollapsibleCard
          expand={ this.isActivityActive(activityTextEnglish) }
          onToggle={ this.toggleActivity }
          key={ activityTextEnglish }
          toggleKey={ activityTextEnglish }
          headerLabel={ this.state.translations.activity }
          headerText={ activityText }
          headerContent={ headerContent }
          content={ content }
          className={ languageName.toLowerCase() + " activity" }
          newEntry={ {risk: newHazardRisk, name:this.state.translations.hazard, callback: this.onSubmitEntry } }
          translations={this.state.translations}
          columnName={(languageName === "English" ? "hazard" : "hazard_" + languageName.toLowerCase())}
          createPending={this.props.updatePending || this.state.loading}
          permission={permission}
        />
      )
    }

    return cards
  }

  renderHazards = (kwargs) => {
    const { hazards, workPhase, activity } = kwargs;
    var { languageName, permission, translations } = this.state
    var cards = []

    for(var index in hazards) {
      var hazard = hazards[index]
      var hidden = null
      let events_count = hazard.unwanted_events.length;
      let events_in_scope_count = 0
      let events_out_of_scope_count = 0

      for(var eventIndex in hazard.unwanted_events) {
        var unwanted_event = hazard.unwanted_events[eventIndex]

        if(unwanted_event.hidden !== null) {
          if (hidden === null){
            hidden = unwanted_event.hidden
          }
          else {
            hidden = hidden || unwanted_event.hidden
          }

          if (unwanted_event.hidden) {
            events_out_of_scope_count++
          } else {
            events_in_scope_count++
          }

        }
      }

      const riskDetails = {
        ...hazard.metadata,
        id: hazard.id,
        is_custom: (['work_phase', 'activity', 'hazard'].includes(hazard.is_custom) ? hazard.is_custom : "unwanted_event"),
        hidden: hidden
      };
      const newUnwantedEventRisk = initNewUnwantedEventEntry(riskDetails);

      const hazardText = (hazard.translations[languageName] || '').trim();
      const workPhaseTextEnglish = (workPhase.translations["English"] || '').trim();
      const activityTextEnglish = (activity.translations["English"] || '').trim();
      const hazardTextEnglish = (hazard.translations["English"] || '').trim();
      const pendingReview = this.findPendingReview({ workPhaseText: workPhaseTextEnglish, activityText: activityTextEnglish, hazardText: hazardTextEnglish });

      var headerContent = (
        <RiskCard
          className={ `cards-workphase-name ${languageName.toLowerCase()} hazard` }
          workPhase={workPhase}
          activity={activity}
          hazard={hazard}
          risk={newUnwantedEventRisk}
          onUpdatePending={ this.props.updateByLevelPending && (this.updateId === hazardTextEnglish ) }
          onDeletePending={ this.props.deleteByLevelPending && (this.updateId === hazardTextEnglish ) }
          onSaveClick={ this.onUpdateRisks }
          onDeleteClick={ this.onDeleteRisks }
          switchRisksVisibility={ this.switchRisksVisibility }
          languageName={languageName}
          translations={translations}
          permission={permission}
          selectLabel={translations.in_scope}
          unselectLabel={translations.out_of_scope}
          inScope={events_in_scope_count === events_count}
          outOfScope={events_out_of_scope_count === events_count}
          pendingReview={pendingReview}
          cardType="Hazard"
          riskIds={hazard.ids}
        />
      )

      var content = this.renderUnwantedEvents({ unwantedEvents: hazard.unwanted_events, workPhase, activity, hazard })

      cards = cards.concat(
        <CollapsibleCard
          expand={ this.isActivityActive(hazardTextEnglish) }
          onToggle={ this.toggleActivity }
          key={ hazardTextEnglish }
          toggleKey={ hazardTextEnglish }
          headerLabel={ this.state.translations.hazard }
          headerText={ hazardText }
          headerContent={ headerContent }
          content={ content }
          className={ `${languageName.toLowerCase()} hazard`  }
          newEntry={ {risk: newUnwantedEventRisk, name: this.state.translations.unwanted_event, callback: this.onSubmitEntry } }
          translations={this.state.translations}
          columnName={(languageName === "English" ? "unwanted_event" : "unwanted_event_" + languageName.toLowerCase())}
          createPending={this.props.updatePending || this.state.loading}
          permission={permission}
        />
      )
    }

    return cards
  }

  renderUnwantedEvents = (kwargs) => {
    const { unwantedEvents, workPhase, activity, hazard } = kwargs;
    const { languageName, permission, translations } = this.state

    return unwantedEvents.map((unwanted_event, index) => {

      const workPhaseTextEnglish = (workPhase.translations["English"] || '').trim();
      const activityTextEnglish = (activity.translations["English"] || '').trim();
      const hazardTextEnglish = (hazard.translations["English"] || '').trim();
      const unwantedEventTextEnglish = (unwanted_event.translations["English"] || '').trim();
      const pendingReview = this.findPendingReview({ workPhaseText: workPhaseTextEnglish, activityText: activityTextEnglish, hazardText: hazardTextEnglish, unwantedEventText: unwantedEventTextEnglish });

      const toggled_unwanted_event = [true, false].includes(unwanted_event.hidden)

      const headerContent = (
        <RiskCard
          className={ `cards-workphase-name ${languageName.toLowerCase()} unwanted-event` }
          workPhase={workPhase}
          activity={activity}
          hazard={hazard}
          unwantedEvent={unwanted_event}
          risk={unwanted_event}
          onUpdatePending={ this.state.updateLoading && (this.updateId === unwanted_event.ids[0]) && (this.updateType === "update") }
          onDeletePending={ this.state.updateLoading && (this.updateId === unwanted_event.ids[0]) && (this.updateType === "delete") }
          onSaveClick={ (value, oldValue, column_name, updated_risk) => this.onUpdateUnwantedEvent(value, updated_risk) }
          onDeleteClick={ (search_term, column_name, deleted_risk) => this.onDeleteUnwantedEvent(deleted_risk) }
          switchRisksVisibility={ this.switchRisksVisibility }
          languageName={languageName}
          translations={translations}
          permission={permission}
          selectLabel={translations.in_scope}
          unselectLabel={translations.out_of_scope}
          inScope={!unwanted_event.hidden && toggled_unwanted_event}
          outOfScope={unwanted_event.hidden && toggled_unwanted_event}
          pendingReview={pendingReview}
          cardType="Unwanted Event"
          refreshPendingReviews={this.refreshPendingReviews}
          riskIds={unwanted_event.ids}
        />
      )

      return (
        <div className="collapsible" key={ unwanted_event.translations["English"] + "_" + index }>
          <div className="collapsible header">
            <div className="collapsible-header-label">
              <Label className="text unwanted-event">{translations.unwanted_event}</Label>
            </div>
            <div className={`collapsible-header-text unwanted-event ${languageName.toLowerCase()}`}>
              { headerContent }
            </div>
          </div>
        </div>
      )
    })
  }

  openScope = (plan) => {
    history.push({
      pathname: paths.PLAN_ACTIVITIES_PATH.replace(":plan_id", plan.id),
      state: { plan: plan }
    })
  }

  openCreatePlanModal = () => {
    const options = { is_template:true }
    this.props.getPlans(options).then(() => {
      if( this.props.plans){
        this.setState({
          templates: this.props.plans,
          templateOptions: this.formatPlans(this.props.plans),
          createPlanModalShown: true,
        })
      }
    })
  }

  onCreatePlan = (templateId, plan, participants) => {
    const newPlanParams = {
      plan_name: plan.name,
      plan_permissions: plan.plan_permissions,
      template_plan_id: templateId,
      participants: participants,
    }

    this.props.newPlan(newPlanParams)
    this.setState({ createPlanModalShown: null })
  }

  hasRiskInScope = (riskTree) => {
    let hasRiskInScope = false;

    WORKPHASELOOP:
    for (let workphase of riskTree) {
      for (let activity of workphase.activities) {
        for (let hazard of activity.hazards) {
          for (let event of hazard.unwanted_events) {
            if (event.hidden === false) {
              hasRiskInScope = true
              break WORKPHASELOOP;
            }
          }
        }
      }
    }
    return hasRiskInScope
  }

  toggleProjCtrlRgstrBtn = () => {
    const { riskTree } = this.state;
    this.setState({
      projCtrlRgstrBtnShown: this.hasRiskInScope(riskTree)
    });
  }

  togglePendingReviews = () => {
    this.setState({ pendingReviewsShown: !this.state.pendingReviewsShown })
  }

  getURLSearchParams = () => {
    const { location } = this.props;
    if (!location.search) return;

    return new URLSearchParams(location.search);
  }

  refreshPendingReviews = () => {
    fetchPlanWithPendingReviews(this.state.planId, (plan) => {
      this.setState({
        pendingReviews: formatPendingReviews(plan.pending_reviews)
      })
    })
  }

  findPendingReview = (kwargs) => {
    const { pendingReviews } = this.state;
    if (!pendingReviews) return null;

    const { workPhaseText, activityText, hazardText, unwantedEventText } = kwargs;

    if (workPhaseText && activityText && hazardText && unwantedEventText) {
      return pendingReviews.find((review) => review.work_phase_or_ambient_exposure.trim() === workPhaseText && review.activity.trim() === activityText && review.hazard.trim() === hazardText && review.unwanted_event.trim() === unwantedEventText);
    } else if (workPhaseText && activityText && hazardText) {
      return pendingReviews.find((review) => review.work_phase_or_ambient_exposure.trim() === workPhaseText && review.activity.trim() === activityText && review.hazard.trim() === hazardText);
    } else if (workPhaseText && activityText) {
      return pendingReviews.find((review) => review.work_phase_or_ambient_exposure.trim() === workPhaseText && review.activity.trim() === activityText);
    } else if (workPhaseText) {
      return pendingReviews.find((review) => review.work_phase_or_ambient_exposure.trim() === workPhaseText);
    }

  }

  setExpandedCards = (expandedCards) => {
    const { expandedWorkPhaseCard, expandedActivityCard, expandedHazardCard } = expandedCards;
    let { activeCards } = this.state;
    activeCards = activeCards.concat([expandedWorkPhaseCard, expandedActivityCard, expandedHazardCard])
    this.setState({ activeCards }, () => this.scrollToWorkPhaseCard(expandedWorkPhaseCard))
  }

  scrollToWorkPhaseCard = (workPhaseText) => {
    const workPhaseId = textToHash(workPhaseText);
    const divElement = document.querySelector(`div[id='${workPhaseId}']`);
    if (divElement) divElement.scrollIntoView();
  }

  setExpandedCardsFromUrlSearchParams = () => {
    if (!this.URLSearchParams) return;

    const reviewItem = Object.fromEntries(this.URLSearchParams);

    if (!reviewItem.search_item_in_scope) return;

    let { work_phase_or_ambient_exposure: expandedWorkPhaseCard='', activity: expandedActivityCard='', hazard: expandedHazardCard='' } = reviewItem;
    this.setExpandedCards({ expandedWorkPhaseCard, expandedActivityCard, expandedHazardCard });
  }

  scrollToWorkPhaseCardFromUrlSearchParams = () => {
    if (!this.URLSearchParams) return;

    const reviewItem = Object.fromEntries(this.URLSearchParams);

    if (!reviewItem.search_item_in_scope) return;

    let { work_phase_or_ambient_exposure: expandedWorkPhaseCard='' } = reviewItem;
    this.scrollToWorkPhaseCard(expandedWorkPhaseCard)
  }

  render() {
    const { pendingReviews, permission, translations } = this.state;
    const { new_plan, open_plan, select_activities, goto_project, require_review, expand_activities, collapse_activities,
            return_to_scope, edit_template } = this.state.translations

    const createPlanItem = <Menu.Item name='new_plan' onClick={this.openCreatePlanModal}><span className="sidebar-button-wrap"><Icon name='plus'></Icon><div>{new_plan}</div></span></Menu.Item>

    const planScopeTip = toolTipManager.getById(PLAN_SCOPE_TIP_ID);
    const { features } = this.props.instanceConfig;

    return (
      <div className="App">
        <Sidebar.Pushable as={ Segment } id='plan-segment'>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={this.state.sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={ () => this.hideSideBar() }
          >
            {
              this.props.isAdmin &&
              <Menu.Item name='home' as={Link} to={paths.DASHBOARD_PATH + '/risk_templates'}>
                <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div> {edit_template}</div></span>
              </Menu.Item>
            }
            { this.props.isAdmin &&
              <CreatePlanModal
                trigger={ createPlanItem }
                shown={ this.state.createPlanModalShown }
                templates={ this.state.templates }
                templateOptions={ this.state.templateOptions }
                onCreatePlan={this.onCreatePlan}
                loading={this.state.planPending}
                onClose={() => this.setState({ createPlanModalShown: null })}
                translations={this.state.translations}
                isAdmin={this.props.isAdmin} />
            }
            <Menu.Item name='home' as={Link} to={paths.DASHBOARD_PATH + '/risk_plans'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div>{open_plan}</div></span>
            </Menu.Item>
            <Menu.Item className="selected" onClick={()=>this.openScope(this.props.location.state.plan)}>
              <span className="sidebar-button-wrap"><Icon name='eye'></Icon><div> {return_to_scope}</div></span>
            </Menu.Item>
            {
              this.state.projCtrlRgstrBtnShown &&
              <Menu.Item name='plan_table' onClick={() => history.push("/plan/" + this.state.planId)}>
                <span className="sidebar-button-wrap"><Icon name='eye slash alternate'></Icon><div> {goto_project}</div></span>
              </Menu.Item>
            }
            <ControlsLink plan_name={this.state.planName}/>
            <Menu.Item name='send_feedback' onClick={()=>{}}>
              <span className="sidebar-button-wrap"><Feedback translations={this.state.translations}/></span>
            </Menu.Item>
            <Menu.Item>
              <ObjectITButton />
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic className="plan-activities-header">
              <SystemHeader
                toggleSideBar={this.toggleSideBar}
                planName={this.state.planName}
                showLogout={true}
                view='cards'
                showLoading={this.state.updateLoading || this.state.loading}
                showNoActivities={ !this.state.loading && this.state.riskCards === {} }
                showMenuButton={true}
                showLanguage={true}
                permission={this.state.permission}
              />
              <div className="project-scope-header">
                <div className="select-in-scope-instruction ui header">{select_activities}</div>
                <div className="project-scope-action-btns">
                  {
                    (this.state.activeCards !== null && this.state.activeCards.length < this.allWorkPhases.length) &&
                    <a color="blue" onClick={ () => this.toggleActivities(true) }>{expand_activities}</a>
                  }
                  {
                    (this.state.activeCards === null || this.state.activeCards.length > 0) &&
                    <a color="blue" onClick={ () => this.toggleActivities(false) }>{collapse_activities}</a>
                  }
                  {
                    pendingReviews.length > 0 && permission.can_update &&
                    <div className="template-changes-review-button" onClick={ this.togglePendingReviews }>
                      <a>{ translations.require_review }</a>
                      <sup className="ui red circular label">{pendingReviews.length}</sup>
                    </div>
                  }
                </div>
                <div className="project-ctrl-rgstr-btn-wrap">
                  <Button
                    color='blue' fluid size='medium'
                    onClick={() => history.push("/plan/" + this.state.planId)}
                    className="project-ctrl-rgstr-btn"
                    disabled={!this.state.projCtrlRgstrBtnShown}
                  >
                    <i className="eye slash alternate icon"></i>
                    {goto_project}
                  </Button>
                </div>
                <div className="plan-scope-tool-tip-container">
                  { features && features.tool_tips && planScopeTip && (
                    <div className="scope-tool-tip-wrapper">
                      <ToolTip
                        title={planScopeTip.title}
                        description={planScopeTip.description}
                        video={planScopeTip.video_link}
                        size='medium'
                      />
                    </div>
                  )}
                </div>
              </div>
              <TemplateUpdateModal
                page={ this.page }
                shown={ this.state.pendingReviewsShown && (pendingReviews.length > 0) && this.state.permission.can_update }
                pendingReviews={ pendingReviews }
                onClose={ () => this.setState({ pendingReviewsShown: false }) }
                translations={ this.state.translations }
                parentView='Project Scope'
                refreshPendingReviews={this.refreshPendingReviews}
                callbackForMarkAsInScope={this.getRiskTree}
                setExpandedCards={this.setExpandedCards}
              />
              <div className="cards-div">
                <div className="cards-area">
                  { this.state.riskTree && this.renderWorkPhases() }
                </div>
              </div>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    user: state.app_token.user,
    risk: state.risk.risk,
    updateSuccess: state.risk.updateSuccess,
    updatePending: state.risk.pending,
    toggledRiskResult: state.risk.result,
    toggledRiskId: state.risk.id,
    toggledRiskValue: state.risk.hidden,
    updateByLevelPending: state.risk.updateByLevelPending,
    updateByLevelSuccess: state.risk.updateByLevelSuccess,
    updateByLevelRisks: state.risk.updateByLevelRisks,
    deleteByLevelPending: state.risk.deleteByLevelPending,
    deleteByLevelSuccess: state.risk.deleteByLevelSuccess,
    deleteByLevelRisks: state.risk.deleteByLevelRisks,
    plan: state.plan.plan,
    loadSuccess: state.plan.loadSuccess,
    plans: state.plan.plans,
    getPlansSuccess: state.plan.getPlansSuccess,
    getPlansPending: state.plan.getPlansPending,
    isTemplate: state.plan.isTemplate,
    createPlanPending: state.plan.createPending,
    language: state.language.language,
    languages: state.language.languages,
    tree: state.plan.tree,
    isAdmin: state.app_token.isAdmin,
    instanceConfig: state.instance.instanceConfig
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    loadPlan: (options) => {
      dispatch(loadPlan(options))
    },
    resetLoad: () => {
      dispatch(loadPlanFailure())
    },
    createRisk: (planId, risk) => {
      dispatch(createRisk(planId, risk))
    },
    resetCreate: () => {
      dispatch(createRiskFailure())
    },
    getPlans: (options) => dispatch(getPlans(options)),
    openPlanPage: (plan_id) => {
      openPlanPage(plan_id);
    },
    resetGetPlans: () => {
      dispatch(getPlansFailure());
    },
    newPlan: (template_plan_id, planName) => {
      dispatch(createNewPlan(template_plan_id, planName))
    },
    updateRisk: (plan_id, risk) => {
      dispatch(updateRisk(plan_id, risk))
    },
    deleteRisk: (plan_id, risk) => {
      dispatch(deleteRisk(plan_id, risk))
    },
    updateRiskByLevel: (plan_id, new_value, search_term, column_name, work_phase, activity) => {
      dispatch(updateRiskByLevel(plan_id, new_value, search_term, column_name, "true", work_phase, activity))
    },
    deleteRiskByLevel: (plan_id, search_term, column_name, work_phase, activity) => {
      dispatch(deleteRiskByLevel(plan_id, search_term, column_name, "true", work_phase, activity))
    },
    switchRisksVisibilityByLevel: (params) => {
      dispatch(switchRisksVisibilityByLevel(params))
    },
    clearRisk: () => {
      dispatch(clearRisk())
    },
    getTranslations: (name) => {
      dispatch(getTranslations(name))
    },
    getTree: (planId, view_type) => {
      dispatch(getTree(planId, view_type))
    },
    uploadPlanToInterpreter: (planId) => {
      dispatch(uploadPlanToInterpreter(planId))
    },
    snackbarAddMessage: (message) => {
      dispatch(snackbarAddMessage(message))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanScope)



// WEBPACK FOOTER //
// ./src/views/plan_scope/index.js